import {
  REQUEST_SEND_FEEDBACK,
  SEND_FEEDBACK_SUCCESS,
  SEND_FEEDBACK_FAILURE
} from "../actions/types";

/** Feedback slice of the store. The reducer is currently a pass-through. */
export type FeedbackState = Record<string, never>;

export interface FeedbackAction {
  type: string;
}

export const initialFeedbackState: FeedbackState = {};

/*
 * Responds to feedback actions and updates the appropriate state
 */
export function handleFeedbackActions(
  state: FeedbackState | undefined,
  action: FeedbackAction
): FeedbackState {
  if (typeof state === "undefined") {
    return initialFeedbackState;
  }
  switch (action.type) {
    case REQUEST_SEND_FEEDBACK:
    case SEND_FEEDBACK_SUCCESS:
    case SEND_FEEDBACK_FAILURE:
    default: {
      return state;
    }
  }
}
